module.exports = __webpack_public_path__ + "static/media/no-picture-room.9af25f2c.png";